import type { HttpClient } from '../../../types/api';
import type { PostDrawCampaignParams, PostDrawCampaignResponse } from '../types';

export const postDrawLotsFromCampaign = async (
  params: PostDrawCampaignParams,
  httpClient: HttpClient,
): Promise<PostDrawCampaignResponse> => {
  return await httpClient.post<PostDrawCampaignResponse>('/user/v1/lottery-draw-lots-from-campaign', {
    body: JSON.stringify({
      lottery_event_branch_id: params.lotteryEventBranchId,
      serial_code: String(params.serialCode).toLocaleUpperCase(),
    }),
  });
};
